import React, { useState } from "react";
import { setCurrentRealm, initKeycloak, getKeycloakInstance } from "../keycloak";

const Login = () => {
  console.log("🧭 Login component rendered");
  const [username, setUsername] = useState("");
  const [organization, setOrganization] = useState("");

 /* 01/01 ACB added mapping which will make it pretty robust
  const orgToRealm = (org) => {
    const x = org.trim().toLowerCase();
    if (x.includes("uhd")) return "UHD_Global";
    if (x.includes("tribanco")) return "Tribanco";
    if (x.includes("lulu")) return "Lulu Financial";
    if (x.includes("idenza")) return "Idenza";
    if (x.includes("casino") || x.includes("casinokai")) return "CasinoKai";
    return "Idenza"; // fallback
  };*/ 
  const orgToRealm = (org) => {
    const raw = (org || "").trim();
    if (!raw) return "Idenza";
  
    const x = raw.toLowerCase();
    const slug = x.replace(/[\s\-_]+/g, ""); // flexible compare
  
    // Canonical realm names as they actually exist in Keycloak today
    const knownRealms = [
      { realm: "UHD_Global", aliases: ["uhdglobal", "uhd", "uhd_global", "uhd global"] },
      { realm: "Tribanco", aliases: ["tribanco"] },
      { realm: "Lulu Financial", aliases: ["lulufinancial", "lulu", "lulu_financial", "lulu financial"] },
      { realm: "Idenza", aliases: ["idenza"] },
      { realm: "CasinoKai", aliases: ["casinokai", "casino", "casino kai"] },
  
      // ✅ New realm (lowercase)
      { realm: "theropay", aliases: ["theropay", "thero", "thero pay", "thero-pay", "thero_pay"] },
      // New SSB Bank realm
      { realm: "ssbbank", aliases: ["ssbbank", "ssb", "ssb bank", "ssbbank"] },
      { realm: "epicsweep", aliases: ["epicsweep", "epic sweep", "epic_sweep"] },
    ];
  
    // 1) Match against aliases (case/space/underscore/hyphen tolerant)
    for (const { realm, aliases } of knownRealms) {
      if (aliases.some((a) => slug === a.replace(/[\s\-_]+/g, ""))) {
        return realm;
      }
    }
  
    // 2) If user typed an existing realm name exactly (case-insensitive), use it
    // (helps when user knows the exact realm)
    const exactMatch = knownRealms.find(({ realm }) => realm.toLowerCase() === x);
    if (exactMatch) return exactMatch.realm;
  
    // 3) Final fallback: assume they typed the realm key and DO NOT mutate it
    // (Prevents breaking realms like "Lulu Financial")
    return raw;
  };
  
  /*
  const handleLogin = async (e) => {
    e.preventDefault();
    console.log("🟢 handleLogin() fired");

    if (!username || !organization) {
      alert("Please enter Username and Organization.");
      return;
    }

    sessionStorage.setItem("username", username);
    sessionStorage.setItem("organization", organization);

    const realmKey = orgToRealm(organization);
    console.log("🔹 Choosing realm:", realmKey);
    setCurrentRealm(realmKey);

    const redirectUri = `${window.location.origin}/rules?realm=${encodeURIComponent(
      realmKey
    )}`;
    console.log("🔹 Redirect URI for login:", redirectUri);

    try {
      console.log("🔄 Initializing Keycloak (check-sso) before login...");
      const kc = await initKeycloak();   // will hydrate adapter if SSO already exists
      const keycloak = kc || getKeycloakInstance();

      if (!keycloak || typeof keycloak.login !== "function") {
        console.error("❌ keycloak instance not available or login not a function");
        return;
      }

      console.log("🔑 Keycloak instance is ready. Redirecting to Keycloak login...");
      await keycloak.login({ redirectUri });
      // No code after this runs until redirect back to /rules.
    } catch (error) {
      console.error("❌ Error during login:", error);
    }
  };*/
  //11/28 ACB Modified
  const handleLogin = (e) => {
    e.preventDefault();
    console.log("🟢 handleLogin() fired");

    if (!username || !organization) {
      alert("Please enter Username and Organization.");
      return;
    }

    // store for later display
    sessionStorage.setItem("username", username);
    sessionStorage.setItem("organization", organization);

    const realmKey = orgToRealm(organization);
    console.log("🔹 Choosing realm:", realmKey);
    setCurrentRealm(realmKey);

    const target = `/rules?realm=${encodeURIComponent(realmKey)}`;
    console.log("🔹 Navigating to:", target);

    // ✅ Let Navigator + Keycloak own the actual login redirect flow
    window.location.href = target;
  };

  

  return (
    <div className="flex justify-center items-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
        <h2 className="text-2xl font-semibold text-center mb-6">Login</h2>
        <form onSubmit={handleLogin}>
          {/* Username input */}
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Username:
            </label>
            <input
              type="text"
              className="w-full p-2 border rounded"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          {/* Organization input */}
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">
              Organization Name:
            </label>
            <input
              type="text"
              className="w-full p-2 border rounded"
              value={organization}
              onChange={(e) => setOrganization(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            className="w-full bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600"
          >
            Proceed to Keycloak Login
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
